import { Component, Input, OnInit } from '@angular/core';

import { FlyingclubSummary } from '../models/flyingclub-summary.model';
import {BusinessManagerService} from '../../shared/user/business-manager.service';


@Component({
  selector: 'app-flyingclub-summary',
  templateUrl: './flyingclub-summary.component.html',
  styleUrls: ['./flyingclub-summary.component.scss']
})
export class FlyingclubSummaryComponent implements OnInit {
  isFlightDeckAdmin = false;
  @Input() flyingClub: FlyingclubSummary;

  constructor( private businessManagerService: BusinessManagerService ) { }

  async ngOnInit() {
    this.isFlightDeckAdmin = await this.businessManagerService.isFlightDeckAdmin();
  }

  get iconUrl(): string {
    if (this.flyingClub.clubType && this.flyingClub.clubType === 'AOPA Network Club') {
      return 'assets/icons/networkicon.png';
    }
    if (this.flyingClub.clubType && this.flyingClub.clubType === 'Club In Formation') {
      return 'assets/icons/informationicon.png';
    }
    return 'assets/icons/othericon.png';
  }

  get listingBackground(): string {
    if (this.isFlightDeckAdmin && this.flyingClub.hideBusiness) {
      return 'not-ok';
    } else if (this.isFlightDeckAdmin && this.flyingClub.notApproved) {
      return 'not-approved';
    } else {
      return 'business-summary';
    }
  }
}
